/* hero slider (homepage). Slide switching/dots/arrows adapted from
   sursa de referință (same scrollLeft-based index tracking on the
   scroll-snap track), scoped per [data-dl-hero-slider] instance instead of the reference page's hardcoded
   data-scope id. "Swipe" is native — the track is overflow-x:auto + scroll-snap-type:x, so touch
   scrolling already works with zero JS (see section-hero-slider.css). Autoplay is new (not on
   the reference site): driven by data-autoplay/data-interval, paused on hover/focus.

   Shopify replaces this whole section's markup on every theme-editor edit, but never tears down
   what the OLD node's script attached — nothing else does it for us. Left alone, the autoplay
   timer (plus its hover/focus listeners) keeps running forever on a detached, invisible
   node, and one more accumulates on every edit. shopify:section:unload is dispatched natively by
   Shopify right before a section's old node is discarded (theme.js does not listen for it, so
   each section script that starts a timer is responsible for clearing it itself); every listener
   this file adds is tracked per-instance and torn down there, and data-bound is cleared last so a
   re-bind of the same node (if that node is ever reused) starts clean, with no duplicates.

   Autoplay is a chained setTimeout, not a fixed-interval timer: every slide may carry its own
   data-duration, falling back to the section interval. */
(function () {
  'use strict';

  function initHeroSlider(root) {
    root.querySelectorAll('[data-dl-hero-slider]:not([data-bound])').forEach(bindHeroSlider);
  }

  /* Cuvintele de sub titlu ([data-dl-hero-words], setarea `rotating_words`): markup-ul poartă lista întreagă,
     despărțită prin virgule (citibilă fără JS). Aici lista se desface și se arată câte un cuvânt, schimbat la
     fiecare ~2,6 s; cu „mișcare redusă” rămâne doar primul cuvânt, fără schimbări. Ca pagina să nu sară, elementul primește ca înălțime
     minimă înălțimea celei mai înalte fraze (remăsurată la schimbarea lățimii). Timerul merge doar cât eroul e pe
     ecran (IntersectionObserver) și se oprește odată cu secțiunea (unload). Pentru cititoarele de ecran lista
     întreagă rămâne în pagină (ascunsă vizual), iar cuvântul afișat e decorativ (aria-hidden). */
  function bindWords(section, teardown) {
    var el = section.querySelector('[data-dl-hero-words]');
    if (!el || el.dataset.boundWords) return;
    var full = el.textContent;
    var words = full.split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    if (words.length < 2) return;
    // „Mișcare redusă”: ca pe naturvia.ro se vede un singur beneficiu (primul), fără schimbări; lista întreagă rămâne
    // pentru cititoarele de ecran.
    var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    el.dataset.boundWords = '1';
    el.textContent = '';
    var all = document.createElement('span');
    all.className = 'dl-hero-words-all';
    all.textContent = words.join(', ');
    var stage = document.createElement('span');
    stage.className = 'dl-hero-words-stage';
    stage.setAttribute('aria-hidden', 'true');
    el.appendChild(all); el.appendChild(stage);
    var i = 0;
    var show = function (animate) {
      stage.textContent = '';
      var span = document.createElement('span');
      span.className = 'dl-hero-word';
      if (animate === false) span.style.animation = 'none';
      span.textContent = words[i];
      stage.appendChild(span);
    };
    // înălțimea celei mai înalte fraze, măsurată pe elementul adevărat (aceeași lățime, același font)
    var reserve = function () {
      var keep = i; var max = 0;
      el.style.minHeight = '';
      for (var k = 0; k < words.length; k++) { i = k; show(false); max = Math.max(max, el.offsetHeight); }
      i = keep; show(false);
      if (max) el.style.minHeight = max + 'px';
    };
    if (still) {
      show(false);
      teardown.push(function () { el.textContent = full; delete el.dataset.boundWords; });
      return;
    }
    reserve();
    var wordsTimer = null; var onScreen = true;
    var next = function () {
      wordsTimer = setTimeout(function () {
        if (!document.hidden && onScreen) { i = (i + 1) % words.length; show(); }
        next();
      }, 2600);
    };
    next();
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) { onScreen = entries[entries.length - 1].isIntersecting; });
      io.observe(el);
    }
    var resizeTimer = null;
    var onResize = function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(reserve, 150); };
    window.addEventListener('resize', onResize);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (el.dataset.boundWords) reserve(); });
    teardown.push(function () {
      if (wordsTimer) clearTimeout(wordsTimer); wordsTimer = null;
      if (io) io.disconnect();
      clearTimeout(resizeTimer); window.removeEventListener('resize', onResize);
      el.style.minHeight = ''; el.textContent = full; delete el.dataset.boundWords;
    });
  }

  function bindHeroSlider(section) {
    section.dataset.bound = '1';

    var track = section.querySelector('.dl-hero-slides');
    var slides = track ? track.querySelectorAll('.dl-hero-slide') : [];
    var teardown = []; // every listener/timer this bind starts — run in full on unload

    function on(el, evt, handler, opts) {
      el.addEventListener(evt, handler, opts);
      teardown.push(function () { el.removeEventListener(evt, handler, opts); });
    }

    section._dlHeroCleanup = function () {
      teardown.forEach(function (fn) { fn(); });
      teardown.length = 0;
      section._dlHeroCleanup = null;
      delete section.dataset.bound;
    };

    bindWords(section, teardown);

    if (!track || slides.length < 2) return; // nothing to navigate — single slide or missing track

    var dots = section.querySelectorAll('.dl-hero-dot');
    var prevBtn = section.querySelector('[data-dl-hero-prev]');
    var nextBtn = section.querySelector('[data-dl-hero-next]');

    var currentIndex = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var setActive = function (idx) {
      dots.forEach(function (dot, i) {
        var isActive = i === idx;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      var changed = false;
      slides.forEach(function (slide, i) {
        if (slide.classList.contains('is-active') !== (i === idx)) changed = true;
        slide.classList.toggle('is-active', i === idx);
      });
      if (changed) schedule(); // the new slide gets its own full duration, however it was reached
    };
    var goTo = function (idx) {
      idx = Math.max(0, Math.min(slides.length - 1, idx));
      track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
    };

    dots.forEach(function (dot, i) {
      on(dot, 'click', function () { goTo(i); });
    });
    if (prevBtn) on(prevBtn, 'click', function () { goTo(currentIndex() - 1); });
    if (nextBtn) on(nextBtn, 'click', function () { goTo(currentIndex() + 1); });

    var ticking = false;
    on(track, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        setActive(currentIndex());
        ticking = false;
      });
    }, { passive: true });

    var timerId = null;
    var paused = false;
    var autoplay = section.dataset.autoplay === 'true';
    function schedule() {
      if (timerId) clearTimeout(timerId);
      timerId = null;
      if (!autoplay) return;
      var idx = currentIndex();
      var slide = slides[idx];
      var wait = Number(slide && slide.dataset.duration) || Number(section.dataset.interval) || 6000;
      timerId = setTimeout(function () {
        timerId = null;
        if (paused || document.hidden) { schedule(); return; }
        goTo(idx >= slides.length - 1 ? 0 : idx + 1);
        // goTo → scroll → setActive → schedule(). If the scroll never happens (reduced-motion
        // browsers that jump without events, a zero-width track), re-arm here as a safety net.
        schedule();
      }, wait);
    }
    if (autoplay) {
      on(section, 'mouseenter', function () { paused = true; });
      on(section, 'focusin', function () { paused = true; });
      on(section, 'mouseleave', function () { paused = false; });
      on(section, 'focusout', function () { paused = false; });
      teardown.push(function () { if (timerId) clearTimeout(timerId); timerId = null; });
      schedule();
    }
  }

  document.addEventListener('shopify:section:unload', function (e) {
    var target = e.target;
    if (!target) return;
    if (target.matches && target.matches('[data-dl-hero-slider]') && typeof target._dlHeroCleanup === 'function') {
      target._dlHeroCleanup();
    }
    if (target.querySelectorAll) {
      target.querySelectorAll('[data-dl-hero-slider]').forEach(function (section) {
        if (typeof section._dlHeroCleanup === 'function') section._dlHeroCleanup();
      });
    }
  });

  // theme.js sits at the very end of <body> (after every section's own markup/scripts, see
  // theme.liquid), so as a *deferred* script it always runs after this one — window.DL does not
  // exist yet at this top-level point, only by DOMContentLoaded (every deferred script, in either
  // order, has run by then). Bind straight away for the current page, and register with DL.use
  // (if DL loaded) so a *future* shopify:section:load — a theme-editor re-render swapping in a
  // brand-new node — gets bound too; initHeroSlider's own [data-dl-hero-slider]:not([data-bound])
  // guard makes calling it here AND via DL.init(document) (which theme.js's own DOMContentLoaded
  // handler triggers) harmless either way.
  document.addEventListener('DOMContentLoaded', function () {
    initHeroSlider(document);
    if (window.DL && typeof window.DL.use === 'function') window.DL.use(initHeroSlider);
  });
})();
